<template>
  <div class="litquiditySignUpsDashboard">
    <div class="litquiditySignUpsDashboard__header">
      <div class="litquiditySignUpsDashboard__title">{{ pageTitle }}</div>
    </div>
    <div class="litquiditySignUpsDashboard__buttons">
      <div class="litquiditySignUpsDashboard__button">
        <span class="text" @click="downloadLitquidity">{{ litquidityButtonText }}</span>
      </div>
      <div
        v-if="isAdmin"
        class="litquiditySignUpsDashboard__button"
      >
        <span class="text" @click="downloadFlightGroup">Flight Group</span>
      </div>
      <div
        v-if="isAdmin"
        class="litquiditySignUpsDashboard__button"
      >
        <span class="text" @click="downloadFlightShareRequests">Flight share requests</span>
      </div>
      <div
        v-if="isAdmin"
        class="litquiditySignUpsDashboard__button"
      >
        <span class="text" @click="downloadLitFlightShareRequests">Lit-Flight share requests</span>
      </div>
      <div
        v-if="isAdmin"
        class="litquiditySignUpsDashboard__button"
      >
        <span class="text" @click="downloadGroupedFlightShareRequests">Grouped Flight Share</span>
      </div>
    </div>
  </div>
</template>

<script>
import './LitquiditySignUps.styl'
import { reportsAPI } from '@/api/reports';

export default {
  name: 'litquidity-sign-ups',
  props: {
    dashboardType: {
      type: String,
      default: 'analytics',
    },
  },
  computed: {
    isAdmin () {
      return this.dashboardType === 'admin'
    },
    pageTitle () {
      return this.isAdmin ? 'Flight Community' : 'Litquidity SignUps'
    },
    litquidityButtonText () {
      return this.isAdmin ? 'Litquidity' : 'Download'
    },
  },
  methods: {
    async downloadFile (request, fileName) {
      try {
        const { data } = await request()
        const downloadLink = document.createElement('a');
        const blob = new Blob(['\ufeff', data]);
        const url = window.URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = fileName + '_' + new Date().toLocaleDateString().replaceAll('/', '-') + '.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } catch (e) {
        console.log(e)
      }
    },
    downloadLitquidity () {
      return this.downloadFile(reportsAPI.litquiditySignup, 'litquidity_sign_ups_report')
    },
    downloadFlightGroup () {
      return this.downloadFile(reportsAPI.flightGroupSignup, 'flight_group_sign_ups_report')
    },
    downloadFlightShareRequests () {
      return this.downloadFile(reportsAPI.flightShareRequests, 'flight_share_requests_report')
    },
    downloadLitFlightShareRequests () {
      return this.downloadFile(reportsAPI.flightLitShareRequests, 'lit-flight_share_requests_report')
    },
    downloadGroupedFlightShareRequests () {
      return this.downloadFile(reportsAPI.groupedFlightShareRequests, 'grouped_flight_share_report')
    },
  },
}
</script>
